import { FC, getDisplayWeight, buildReceiptCommands } from '../../Services'
import { serializeError } from 'serialize-error'
import { cap } from '../../State'

const createRequestId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

const IPC_TIMEOUT_MS = 30000

const sendCommandsToPrinter = async (commands) => {
  const requestId = createRequestId()
  cap.cassa.setState({ message: '' })

  if (window.ipcBridge) {
    window.ipcBridge.sendToMain(JSON.stringify({ type: 'send', commands, requestId }))
  } else {
    setTimeout(() => cap.cassa.setState({
      message: JSON.stringify({ OK: false, Error: 'No IPC Bridge', requestId })
    }), 2000)
  }

  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      clearInterval(timer)
      resolve({ OK: false, Error: 'Timeout comunicazione con Client cassa', requestId })
    }, IPC_TIMEOUT_MS)
    const timer = setInterval(() => {
      const raw = cap.cassa.state.message
      if (raw === '') return
      try {
        const parsed = JSON.parse(raw)
        if (parsed.requestId && parsed.requestId !== requestId) return
        clearTimeout(timeout)
        clearInterval(timer)
        cap.cassa.setState({ message: '' })
        resolve(parsed)
      } catch {
        clearTimeout(timeout)
        clearInterval(timer)
        cap.cassa.setState({ message: '' })
        resolve({ OK: false, Error: 'JSON Error', requestId })
      }
    }, 200)
  })
}

const buildLine = (magazzino, se) => {
  const Prod = magazzino.find(m => m.Id === se.IdProdotto)
  let desc = se.Note || (Prod ? Prod.Descrizione : 'Prodotto Singolo')
  !se.Note && se.IdProdotto === 0 && (desc = 'Servizio')
  !se.Note && se.IdProdotto === -1 && (desc = 'Sconto')
  !se.Note && se.PesoSfuso > 0 && (desc = 'Sfuso ' + getDisplayWeight(se.PesoSfuso).replace(',', '.') + ' ' + desc)

  const qty = se.Qt || 1
  const unitPriceCents = Math.floor(se.TotaleSingolo / qty)
  const isDiscount = se.TotaleSingolo < 0 || se.IdProdotto === -1

  return {
    desc,
    qty,
    unitPriceCents,
    pesoSfuso: se.PesoSfuso || 0,
    isDiscount,
    discountCents: isDiscount ? Math.abs(se.TotaleSingolo) : 0,
    appReparto: se.PesoSfuso > 0 ? 1 : (isDiscount ? 1 : se.Reparto)
  }
}

const sortScontoCarrello = (carrello) => {
  if (!carrello.find(se => se.TotaleSingolo < 0)) return carrello
  const [prodCaro, ...prodotti] = carrello.filter(se => se.TotaleSingolo > 0).sort((a, b) => b.TotaleSingolo - a.TotaleSingolo)
  if (!prodCaro || !prodCaro.TotaleSingolo) return null
  const totSconti = carrello.filter(se => se.TotaleSingolo < 0).reduce((tot, curr) => curr.TotaleSingolo + tot, 0)
  if (prodCaro.TotaleSingolo < Math.abs(totSconti)) return null
  return [
    prodCaro,
    { IdProdotto: -1, Reparto: 1, Qt: 1, TotaleSingolo: totSconti },
    ...prodotti
  ]
}

const printSale = async (magazzino, carrello, sale, lottery, mockPrinterResponse, { tenderedCents } = {}) => {
  const built = buildReceiptCommands({
    lines: carrello.map(se => buildLine(magazzino, se)),
    payment: sale.Pagamento,
    totalCents: sale.Totale,
    lottery: lottery || '',
    tenderedCents
  })

  if (!built.OK) {
    FC.log({ EventType: 'StampaScontrino', IdTarget: sale.Id, Data: built }, true)
    window.growl.show({
      severity: 'error',
      summary: 'Errore di stampa',
      detail: built.Errors?.join(' ') || 'Impossibile preparare lo scontrino'
    })
    return false
  }

  try {
    if (mockPrinterResponse) {
      console.log(JSON.stringify({ ...built, commands: built.commands }))
      await new Promise(resolve => setTimeout(resolve, 3000))
      return true
    }
    const result = await sendCommandsToPrinter(built.commands)
    FC.log({
      EventType: 'StampaScontrino',
      IdTarget: sale.Id,
      Data: {
        ...result,
        computedSubtotalCents: built.computedSubtotalCents,
        paymentCommand: built.paymentCommand,
        paymentCents: built.paymentCents
      }
    }, !result.OK)
    return result.OK
  } catch (e) {
    FC.log({ EventType: 'StampaScontrino', IdTarget: sale.Id, Data: serializeError(e) }, true)
    return false
  }
}

export const printReceipt = async (magazzino, sale, carrello, mockPrinterResponse, lottery, { tenderedCents } = {}) => {
  if (!sale || !sale.Id) {
    FC.log({ EventType: 'ErroreInPrintReceipt - NoSaleId', Data: { sale, carrello } }, true)
    return false
  }

  const sortedCarrello = sortScontoCarrello(carrello)
  if (!sortedCarrello) {
    window.growl.show({
      severity: 'error',
      summary: 'Battere Scontrino a mano',
      detail: 'Sconto superiore a prodotto più costoso'
    })
    return false
  }

  const success = await printSale(magazzino, sortedCarrello, sale, lottery, mockPrinterResponse, { tenderedCents })

  window.growl.show({
    severity: success ? 'info' : 'error',
    summary: success ? 'Scontrino Stampato' : 'Errore di stampa',
    detail: success ? '' : 'Attendere il reset cassa prima di riprovare'
  })

  success && FC.service('sales').patch(sale.Id, { Processato: mockPrinterResponse ? 0 : 1 })
    .then(() => FC.updateCache(['todaySales', 'daRitirare', 'daEvadere']))
    .catch(err => FC.log({ EventType: 'ErroreInPrintReceiptPatch', Error: serializeError(err), Data: { sale, carrello } }, true))

  return success
}
